import React, { useEffect, useState } from "react";
import { splashApi } from "../lib/api";

const FALLBACK_PHRASES = [
  "Formamos líderes",
  "Built to Lead",
  "Vive y eXperimenta el liderazgo",
  "Lidera con propósito",
  "Supera tus límites",
];

const CACHE_KEY = "supera_splash_phrases";
const MS_KEY = "supera_splash_ms";
const DEFAULT_MS = 3000;

function getCachedPhrases() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    const arr = raw ? JSON.parse(raw) : null;
    if (Array.isArray(arr) && arr.length) return arr;
  } catch {}
  return FALLBACK_PHRASES;
}

function getCachedMs() {
  try {
    const v = parseInt(localStorage.getItem(MS_KEY), 10);
    if (v >= 2000 && v <= 10000) return v;
  } catch {}
  return DEFAULT_MS;
}

// Splash de bienvenida uniforme para TODOS los dispositivos (iOS, Android, tablet, PC).
// Fondo navy + logo Supera + frase motivacional rotativa (editable desde el admin).
// La duración es configurable por el super admin (2–10 s).
export default function SplashScreen() {
  const [fading, setFading] = useState(false);
  const [gone, setGone] = useState(false);
  const [phrase] = useState(() => {
    const pool = getCachedPhrases();
    return pool[Math.floor(Math.random() * pool.length)];
  });
  const [durationMs] = useState(() => getCachedMs());

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), durationMs);
    const t2 = setTimeout(() => setGone(true), durationMs + 600);
    // Refresca frases y duración en segundo plano para la próxima apertura.
    splashApi.phrases()
      .then((d) => {
        if (Array.isArray(d.phrases) && d.phrases.length) localStorage.setItem(CACHE_KEY, JSON.stringify(d.phrases));
        if (d.duration_ms) localStorage.setItem(MS_KEY, String(d.duration_ms));
      })
      .catch(() => {});
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [durationMs]);

  if (gone) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#0A1C30] transition-opacity duration-[600ms] ${fading ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <img src="/logo-supera-light.png" alt="Supera Leadership" className="w-64 sm:w-80 md:w-96 max-w-[68%] h-auto splash-logo-anim" />
      <p data-testid="splash-phrase" className="splash-phrase-anim mt-6 px-8 text-center text-base sm:text-lg font-semibold tracking-wide text-white/90">
        {phrase}
      </p>
    </div>
  );
}
